/**
 * 注册弹窗顶部标题栏
 * - 标题 + 当前步骤副标题 + 关闭按钮
 */
import type { RegisterStep } from '../../../../../stores/registerStore';
import { REGISTER_STEP_TITLES } from '../constants';

export function ModalHeader({
  currentStep,
  onClose,
}: {
  currentStep: RegisterStep;
  onClose: () => void;
}) {
  return (
    <div className="p-6 flex items-center justify-between flex-shrink-0 border-b border-slate-100">
      <div>
        <h3 className="text-xl font-bold text-slate-800">用户注册</h3>
        <p className="text-sm text-slate-500 mt-1">
          {REGISTER_STEP_TITLES[currentStep]}
        </p>
      </div>
      <button
        onClick={onClose}
        className="text-slate-400 hover:text-slate-600 transition-colors p-1 rounded-full hover:bg-slate-100"
      >
        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
  );
}